import React from "react";
import { Link } from "react-router-dom";

export default function TermsBannerComponent() {
  return (
    <div className="Row">
      <div className="col">
        <div className="login-alert">
          <p>
            <strong>Update:</strong> As of May 16th, 2023, our terms have
            changed. By clicking “Login”, you agree to the new terms, which can
            be found{" "}
            <a
              target="_blank"
              href="https://cavsapp.com/terms/">
              here
            </a>
            . CAVS is now managed by{" "}
            <a
              href="https://reason.consulting/"
              role="link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="link to Terms and Conditions"
            >
              Reason Consulting Corporation
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
